// extracted by mini-css-extract-plugin
export default {"promo":"Cyo-module__promo__YI4fJ"};